import { apiFetch } from './client';

export interface FamilyInfo {
  family_id: string;
  group_display_id?: string;
  name?: string;
  timezone: string;
  fair_use: {
    daily_limit: number;
    daily_used: number;
    reset_at: string;
    per_device?: number;
  };
  device_count: number;
  voice_suspended?: boolean;
}

export async function getFamily(): Promise<FamilyInfo> {
  return apiFetch<FamilyInfo>('/v1/family');
}

export async function renameGroup(name: string): Promise<{ name: string; group_display_id: string }> {
  return apiFetch('/v1/family', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
}
